import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Inicio from '../pages/Inicio';
import LoginPage from '../pages/LoginPage';
import PublicRoute from './PublicRoute';

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/admin" element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        } />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
